export default from './delete-confirmation';



// WEBPACK FOOTER //
// ./app/components/delete-confirmation/index.js